import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-review-finsih',
  templateUrl: './modal-review-finsih.component.html',
  styles: []
})
export class ModalReviewFinsihComponent extends ExcTranslation implements OnInit {
  ratings = {};
  selected: {rating: number} = {rating: null};
  selectedRating = null;
  reviewComment = '';
  optScores: {text: string, value: number, disabled: boolean}[] = [];

  constructor(
    private overlayRef: OverlayRef,
    private overlayConfig: OverlayConfig,
    private cdr: ChangeDetectorRef,
    private excDss: DefaultSettingsService
  ) {
    super();
  }

  getKeys() {
    if (this.ratings) {
      return Object.keys(this.ratings);
    }
  }

  getStyle(key) {
    return {
      'border-color': this.ratings[key]['Color'],
      'border-style': 'solid',
      'border-width': '3px',
      'border-radius': '10px',
      'cursor': 'pointer',
      'background-color': (this.selected.rating === key ? this.ratings[key]['Background'] : 'transparent')
    };
  }

  getPercent(value: number, total: number): string {
    if (total === undefined || total === null || Number(total) === 0) {
      return '0,0';
    }

    const percent = (Number(value || 0) / Number(total)) * 100;
    return percent.toFixed(1).replace('.', ',');
  }

  getReviewedNotOk(): number {
    if (
      this.overlayConfig === undefined ||
      this.overlayConfig === null ||
      this.overlayConfig.data === undefined ||
      this.overlayConfig.data === null ||
      this.overlayConfig.data.Balance === undefined ||
      this.overlayConfig.data.Balance === null
    ) {
      return 0;
    }

    const balance = this.overlayConfig.data.Balance;
    const objects = Number(balance.Objects || 0);
    const reviewedOk = Number(balance.ObjectsReviewedOk || 0);

    return Math.max(objects - reviewedOk, 0);
  }

  proceed() {
    this.overlayRef.close({
      proceed: true,
      ReviewRating: this.selected.rating,
      Comment: this.reviewComment
    });
  }

  ngOnInit() {
    this.ratings = undefined;

    if (this.excDss.MandantSettings['ReviewRating'] !== undefined && this.excDss.MandantSettings['ReviewRating'] !== null) {
      this.ratings = {};

      for (const x of Object.keys(this.excDss.MandantSettings['ReviewRating'])) {
        const y = Object.assign({}, this.excDss.MandantSettings['ReviewRating'][x]);

        this.optScores.push({
          disabled: false,
          value: parseInt(x, 0),
          text: y['Title']
        });

        this.ratings[x] = y;
      }

      if (this.overlayConfig.data.AutoScoring !== undefined && this.overlayConfig.data.AutoScoring !== null) {
        if (this.overlayConfig.data.AutoScoring.AutoScoringDone === true) {
          this.selected.rating = this.overlayConfig.data.AutoScoring.AutoScoringResult;
          this.reviewComment = this.overlayConfig.data.AutoScoring.AutoScoringComment;
          this.cdr.detectChanges();
        }
      }
    }
  }

  getLog() {
    console.log('rating =' + this.selected.rating);
    console.log('ratings =' + this.ratings.toString());
  }
}
